module.exports = __webpack_public_path__ + "assets/img/Rosemary-Health-1-Social-Static-Ad-w720.8e4e65cd.png";